<template>
<!-- Header -->
<div class="header" id="heading">

	<!-- Logo -->
	<div class="header-left">
		<router-link to="/index" class="logo">
			<img src="@/assets/img/dkl.png"  alt="Logo" class="sidebar-logo">
			<img src="@/assets/img/dkl_favicon.png"  alt="Logo" class="mini-sidebar-logo">
		</router-link>
	</div>
	<!-- /Logo -->



	<!-- Header Title -->
	<div class="page-title-box">
		<div class="top-nav-search">
				<a href="javascript:void(0);" class="responsive-search">
					<i class="fa fa-building"></i>
			   </a>
      <li class="nav-item dropdown has-arrow main-drop">
        <a href="#" class="dropdown-toggle nav-link">
          <div class="col  p-0">
            <h3 class="page-title m-0">{{$store.state.account_name}} </h3>
          </div>
        </a>
        <div class="dropdown-menu">
          <router-link class="dropdown-item" to="/select-mandant">Mandant wechseln</router-link>
        </div>
      </li>

			</div>
	</div>


	<!-- /Header Title -->

	<a id="mobile_btn" class="mobile_btn" href="#sidebar"><i class="fa fa-bars"></i></a>

	<!-- Header Menu -->
	<ul class="nav user-menu">

		<!-- Search -->
		<li class="nav-item">

		</li>
		<!-- /Search -->

		<!-- Flag -->
		<li class="nav-item dropdown has-arrow flag-nav">
			<a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
				<img src="@/assets/img/flags/de.png" alt="" height="20"> <span>Deutsch</span>
			</a>
			<div class="dropdown-menu dropdown-menu-right">
				<a href="javascript:void(0);" class="dropdown-item">
					<img src="@/assets/img/flags/de.png" alt="" height="16"> Deutsch
				</a>
				<a href="javascript:void(0);" class="dropdown-item">
					<img src="@/assets/img/flags/us.png" alt="" height="16"> English
				</a>
			</div>
		</li>
		<!-- /Flag -->

		<li class="nav-item dropdown has-arrow main-drop">
			<a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
				<span class="user-img"><img src="@/assets/img/profiles/avatar-21.jpg" alt="">
				<span class="status online"></span></span>
				<span>Admin</span>
			</a>
			<div class="dropdown-menu">
				<a class="dropdown-item" to="/settings">Settings</a>
				<a class="dropdown-item" @click="logout">Logout</a>
			</div>
		</li>
	</ul>
	<!-- /Header Menu -->

	<!-- Mobile Menu -->
	<div class="dropdown mobile-user-menu">
		<a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
		<div class="dropdown-menu dropdown-menu-right">
			<router-link class="dropdown-item" to="/settings">Settings</router-link>
			<a class="dropdown-item" href="#" @click="logout">Logout</a>
		</div>
	</div>
	<!-- /Mobile Menu -->

</div>
<!-- /Header -->
</template>
<script>
  import { service } from "@/utils/request";
  export default {
    mounted() {},
    computed: {
         currentPath() {
             return this.$route.name
         }
     },
    methods: {
      logout(e) {
        e.preventDefault()
        this.$store.commit('RESET_ACCOUNT')
        this.$store.commit('RESET_USER')
        service.request({
          url: 'logout/',
          method: 'GET',
        }).then(response => {
          if (response.data === 'User logged out successfully')
            this.$vToastify.success('Abmeldung erfolgreich!')
        }).finally(()=>this.$router.push('/'))
      }
    }
  }
</script>
